import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import userF1 from "../assets/img/User-Female/user-f1.png";
import userF2 from "../assets/img/User-Female/user-f2.png";
import userF3 from "../assets/img/User-Female/user-f3.png";
import userF4 from "../assets/img/User-Female/user-f4.png";
import userF5 from "../assets/img/User-Female/user-f5.png";
import userF6 from "../assets/img/User-Female/user-f6.png";
import userF7 from "../assets/img/User-Female/user-f7.png";
import userF8 from "../assets/img/User-Female/user-f8.png";
import userF9 from "../assets/img/User-Female/user-f9.png";
import userF10 from "../assets/img/User-Female/user-f10.png";

import userM1 from "../assets/img/User-Male/user-m1.png";
import userM2 from "../assets/img/User-Male/user-m2.png";
import userM3 from "../assets/img/User-Male/user-m3.png";
import userM4 from "../assets/img/User-Male/user-m4.png";
import userM5 from "../assets/img/User-Male/user-m5.png";
import userM6 from "../assets/img/User-Male/user-m6.png";
import userM7 from "../assets/img/User-Male/user-m7.png";
import userM8 from "../assets/img/User-Male/user-m8.png";
import userM9 from "../assets/img/User-Male/user-m9.png";
import userM10 from "../assets/img/User-Male/user-m10.png";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";

export const steps = [
  { label: "Cart", icon: <ShoppingCartIcon style={{ fontSize: "18px" }} /> },
  { label: "Address", icon: <LocationOnIcon style={{ fontSize: "18px" }} /> },
  {
    label: "Payment",
    icon: <MonetizationOnIcon style={{ fontSize: "18px" }} />,
  },
];


export const randomMaleLogo = [
  userM1,
  userM2,
  userM3,
  userM4,
  userM5,
  userM6,
  userM7,
  userM8,
  userM9,
  userM10,
];

export const randomFemaleLogo = [
  userF1,
  userF2,
  userF3,
  userF4,
  userF5,
  userF6,
  userF7,
  userF8,
  userF9,
  userF10,
];

export const states = [
  { id: "1", name: "Andhra Pradesh" },
  { id: "2", name: "Arunachal Pradesh" },
  { id: "3", name: "Assam" },
  { id: "4", name: "Bihar" },
  { id: "5", name: "Chhattisgarh" },
  { id: "29", name: "Chandigarh" },
  { id: "30", name: "Delhi" },
  { id: "6", name: "Goa" },
  { id: "7", name: "Gujarat" },
  { id: "8", name: "Haryana" },
  { id: "9", name: "Himachal Pradesh" },
  { id: "32", name: "Jammu and Kashmir" },
  { id: "10", name: "Jharkhand" },
  { id: "11", name: "Karnataka" },
  { id: "12", name: "Kerala" },
  { id: "31", name: "Ladakh" },
  { id: "13", name: "Madhya Pradesh" },
  { id: "14", name: "Maharashtra" },
  { id: "15", name: "Manipur" },
  { id: "16", name: "Meghalaya" },
  { id: "17", name: "Mizoram" },
  { id: "18", name: "Nagaland" },
  { id: "19", name: "Odisha" },
  { id: "20", name: "Punjab" },
  { id: "21", name: "Rajasthan" },
  { id: "22", name: "Sikkim" },
  { id: "23", name: "Tamil Nadu" },
  { id: "24", name: "Telangana" },
  { id: "25", name: "Tripura" },
  { id: "26", name: "Uttar Pradesh" },
  { id: "27", name: "Uttarakhand" },
  { id: "28", name: "West Bengal" },
];


export const trackSteps = [
  {
    label: "Order Confirmed",
    icon: <CheckSharpIcon style={{ fontSize: "18px" }} />,
  },
  {
    label: "Quality Check",
    icon: <CheckSharpIcon style={{ fontSize: "18px" }} />,
  },
  {
    label: "Dispatched Item",
    icon: <CheckSharpIcon style={{ fontSize: "18px" }} />,
  },
  {
    label: "Product Delivered",
    icon: <CheckSharpIcon style={{ fontSize: "18px" }} />,
  },
];